export default "__VITE_PUBLIC_ASSET__9448f050__"